import React from 'react';
import { Box, Typography } from '@mui/material';

const MultiColorProgressBar = ({ segments, totalLabel = "Total for March", totalTime = "2108:18:45" }) => {
    const total = segments.reduce((acc, seg) => acc + seg.value, 0);

    return (
        <Box sx={{ display: 'flex', width: '100%', gap: 5, justifyContent: 'space-between', alignItems: 'start' }}>
            <Box sx={{ width: '100%', }}>
                <Box sx={{ marginBottom: '11px' }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#1A1F36', }}>Employee working time dashboard</Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        width: '100%',
                        height: 24,
                        borderRadius: '4px',
                        overflow: 'hidden',
                        backgroundColor: '#E0E0E0',
                    }}
                >
                    {segments.map((segment, index) => (
                        <Box
                            key={index}
                            sx={{
                                width: `${segment.value}%`,
                                backgroundColor: segment.color,
                                transition: 'width 0.3s ease',
                            }}
                        />
                    ))}
                </Box>
            </Box>

            {total !== 100 && (
                <Typography sx={{ color: 'red', fontSize: '12px', mt: 0.5 }}>
                    Warning: Total progress is {total}%, should be 100%
                </Typography>
            )}

            <Box sx={{ marginTop: 0, }}>
                <Typography sx={{ fontSize: '12px', paddingBottom: '4px', fontWeight: 500 }}>{totalLabel}</Typography>
                <Typography sx={{ fontSize: '18px', color: '#1A1F36', whiteSpace: 'nowrap' }}>{totalTime}</Typography>
            </Box>
        </Box>
    );
};

export default MultiColorProgressBar;
